<p-dialog modal="true" styleClass="atlas-dialog-m" position="top" [closable]="false" [(visible)]="showDialog">

  <ng-template pTemplate="header">
    <h4>{{ 'profiles.contact.email-analytics-dialog.title' | translate }}
    </h4>
  </ng-template>

  <div   class="mb-27 mct-flex mct-row mct-justify-between mct-items-stretch" *ngIf="contact">
    <div class="col-sm-12 text-left-xs">
      <label class="light-text">{{ 'profiles.contact.email-analytics-dialog.subject' | translate | ucfirst }}</label>:
      <b>{{ contact.Subject }}</b>
    </div>
  </div>

  <form [wl-busy-overlay]="loadingStatistics" [busyCenter]="true">
    <div   class="mb-27 mct-flex mct-row mct-justify-between mct-items-stretch" *ngIf="statistics">
      <div class="col-sm-6 text-left-xs">
        <label class="light-text">{{ 'profiles.contact.email-analytics-dialog.times-read' | translate | ucfirst
          }}</label>:
        <b>{{ statistics.ReadTotal }}</b>
      </div>
      <div class="col-sm-3 text-right text-left-xs">
        <label class="light-text">{{ 'profiles.contact.email-analytics-dialog.first-read' | translate | ucfirst
          }}</label>:
        <b>{{ statistics.FirstRead | date: "MM/dd/yyyy"}}</b>
      </div>
      <div class="col-sm-3 text-right text-left-xs">
        <label class="light-text">{{ 'profiles.contact.email-analytics-dialog.last-read' | translate | ucfirst
          }}</label>:
        <b>{{ statistics.LastRead| date: "MM/dd/yyyy" }}</b>
      </div>
    </div>

    <p-table [showGridlines]="true" [value]="statistics?.Clicks">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>
            {{ 'profiles.contact.email-analytics-dialog.grid.link' | translate | ucfirst }}
          </th>
          <th>
            {{ 'profiles.contact.email-analytics-dialog.grid.click-count' | translate | titlecase }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-clickLog>
        <tr>
          <td><a href="{{ clickLog.Url }}" target="_blank">{{ clickLog.Url }}</a></td>
          <td>{{ clickLog.ClickedTotal }}</td>
        </tr>
      </ng-template>
    </p-table>

  </form>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="close()">
        {{ 'common.close' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
